
export enum RegistryStatusEnum {
  DA_INSTALLARE = "DA_INSTALLARE",
  IN_COLLAUDO = "IN_COLLAUDO",
  OPERATIVO = "OPERATIVO"
}
